module.exports = __webpack_public_path__ + "static/media/CHAP04-OUVERTURE.5373c3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP04-OUVERTURE.png
// module id = 300
// module chunks = 0